import React, { memo, useCallback } from "react";
import PropTypes from 'prop-types';
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserDropdown from "components/dropdowns/UserDropdown";
import { Row, Card, Form, Col, InputGroup, ToggleButton, Button } from "react-bootstrap";
import DatePicker from 'react-datepicker';

const Filters = ({ filters, setFilters, handleClick }) => {
    const toggleRating = useCallback((value, checked) => setFilters(current => {
        const rating = new Set(current.rating);
        if (checked) rating.add(value);
        else rating.delete(value);
        return { ...current, rating };
    }), []);

    const clearRating = useCallback(() => setFilters(current => ({ ...current, rating: new Set() })), []);

    return (
        <Card className="p-3">
            <Form.Group as={Row} className="p-2">
                <Col xs={3}>
                    <Form.Label>Date</Form.Label>
                    <InputGroup>
                        <Col xs={5}>
                            <DatePicker
                                calendarStartDay={1}
                                id="date-from"
                                className="form-control text-center"
                                placeholderText="Select From"
                                onChange={date => setFilters({ ...filters, start: new Date(date).toISOString() })}
                                dateFormat={'dd/MM/yyyy'}
                                selected={filters?.start ? new Date(filters?.start) : new Date()}
                                isClearable
                            />
                        </Col>
                        <Col xs={2}>
                            <InputGroup.Text>To</InputGroup.Text>
                        </Col>
                        <Col xs={5}>
                            <DatePicker
                                calendarStartDay={1}
                                id="date-to"
                                className="form-control text-center"
                                placeholderText="Select To"
                                onChange={date => setFilters({ ...filters, end: new Date(date).toISOString() })}
                                dateFormat={'dd/MM/yyyy'}
                                selected={filters?.end ? new Date(filters?.end) : new Date()}
                                isClearable
                            />
                        </Col>
                    </InputGroup>
                </Col>
                <Col xs={3}>
                    <Form.Label>Search</Form.Label>
                    <Form.Control
                        value={filters?.query}
                        type="text"
                        onChange={e => setFilters({ ...filters, query: e.target.value.trim() })}
                        placeholder="Search questions or answers"
                    ></Form.Control>
                </Col>
                <Col xs={3}>
                    <Form.Label>Users</Form.Label>
                    <UserDropdown
                        handleChange={e => setFilters({ ...filters, users: e })}
                        selectedOptions={filters?.users}
                    />
                </Col>
                <Col xs={2}>
                    <Form.Label>Rating</Form.Label>
                    <Col xs={12}>
                        <ToggleButton
                            className="me-2"
                            id="rating-any"
                            type="checkbox"
                            variant="outline-info"
                            value="any"
                            checked={filters?.rating?.size === 0}
                            onChange={clearRating}
                        >Any
                        </ToggleButton>
                        <ToggleButton
                            className="me-2"
                            id="rating-good"
                            type="checkbox"
                            variant="outline-success"
                            value="good"
                            checked={filters?.rating?.has("good")}
                            onChange={e => toggleRating("good", e.currentTarget.checked)}
                        ><FontAwesomeIcon icon={faThumbsUp} />
                        </ToggleButton>
                        <ToggleButton
                            id="rating-bad"
                            type="checkbox"
                            variant="outline-danger"
                            value="bad"
                            checked={filters?.rating?.has("bad")}
                            onChange={e => toggleRating("bad", e.currentTarget.checked)}
                        ><FontAwesomeIcon icon={faThumbsDown} />
                        </ToggleButton>
                    </Col>
                </Col>
                <Col xs={1}>
                    <Button onClick={handleClick}>Search</Button>
                </Col>
            </Form.Group>
        </Card>
    )
}

Filters.propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
    handleClick: PropTypes.func
};

export default memo(Filters);